<template>
  <v-form ref="form">
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="primary--text font-weight-bold edit-quotation-form__title">
          TOMADOR MATRIZ/FILIAL
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="takerNameEditQuotation"
          placeholder="Inserir"
          v-model="form.tomador.nome_fantasia"
          :items="listTaker"
          required
          :rules="[requiredInput]"
          label-text="Tomador Matriz/Filial"
          item-text="nome_fantasia"
          item-value="nome_fantasia"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="takerCNPJEditQuotation"
          placeholder="Inserir"
          v-model="form.tomador.cnpj"
          :items="listTaker"
          required
          :rules="[requiredInput]"
          label-text="CNPJ"
          item-text="cnpj"
          item-value="cnpj"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="font-weight-bold primary--text edit-quotation-form__title">
          SEGURADO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <BaseFormSelect
          id-element="typeInsuredEditQuotation"
          placeholder="Selecione"
          v-model="form.segurado.tipo_pessoa"
          :items="listType"
          required
          :rules="[requiredInput]"
          label-text="Tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <BaseFormAutocomplete
          id-element="cpfCnpjInsuredEditQuotation"
          placeholder="000.000.000-00"
          v-model="form.segurado.numero_documento"
          :items="insuredByNameOrCPFCNPJ"
          hide-no-data
          item-text="numero_documento"
          item-value="numero_documento"
          validate-on-blur
          :rules="validTypeDocumentAccordingOptionsQuotation"
          v-facade="maskCPFCNPJ"
          label-text="CPF/CNPJ"
          @keyup="searchInput"
          :return-object="true"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5 pr-md-0">
        <BaseFormAutocomplete
          id-element="nameInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.nome"
          :items="insuredByNameOrCPFCNPJ"
          :rules="[requiredInput]"
          label-text="Nome"
          hide-no-data
          @keyup="searchInput"
          item-text="nome"
          item-value="nome"
          :return-object="true"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-md-5">
        <BaseFormInput
          id-element="cepInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.cep"
          :rules="validCEPAccordingOptionsQuotation"
          validate-on-blur
          v-facade="maskCEP"
          label-text="CEP"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-0 pr-sm-5">
        <BaseFormInput
          id-element="addressInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.logradouro"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Endereço"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-md-5">
        <BaseFormInput
          id-element="numberInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.numero"
          :rules="validNumberAccordingOptionsQuotation"
          label-text="Número"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5 pr-md-0">
        <BaseFormInput
          id-element="complementInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.complemento"
          label-text="Complemento"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <BaseFormSelect
          id-element="ufInsuredEditQuotation"
          placeholder="Selecione"
          v-model="form.segurado.endereco.uf"
          :items="brazilianStates"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="UF"
          item-text="nome"
          item-value="sigla"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <BaseFormInput
          id-element="cityInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.cidade"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Cidade"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormInput
          id-element="neighborhoodInsuredEditQuotation"
          placeholder="Inserir"
          v-model="form.segurado.endereco.bairro"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Bairro"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="font-weight-bold primary--text edit-quotation-form__title">
          EMISSÃO
        </p>
      </v-col>
      <v-col cols="12" class="mb-5" v-if="isAdditionalCoverageRequired">
        <v-switch
          v-model="form.cobertura_adicional"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Há cobertura adicional
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon color="secondary" size="10" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Selecione esta opção caso o contrato objeto do seguro possua
                  coberturas adicionais a serem inseridas no seguro. Por
                  exemplo, cobertura de multas contratuais ou de obrigações
                  trabalhistas e previdenciárias. Descreva abaixo as condições
                  exigidas.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="12" v-if="isContractInfoRequired">
        <BaseFormTextArea
          id-element="infoContractProcessQuotation"
          placeholder="Informe"
          v-model="form.informacoes_contrato"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Informações do contrato"
          icon-information
          text-information="Aqui você deve descrever todas as características relevantes do contrato que é objeto do seguro garantia para qual solicita cotação. Informações como valores e prazos são essenciais."
        />
      </v-col>
      <fragment v-if="isJudiciaryProcessNumberRequired">
        <v-col
          cols="12"
          sm="6"
          md="5"
          lg="4"
          class="pr-sm-5"
          v-if="isTypeProcessRequired"
        >
          <BaseFormSelect
            id-element="typeEmissionEditQuotation"
            placeholder="Seleção"
            v-model="form.processo.tipo_processo"
            :items="listEmissionType"
            item-text="title"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            label-text="Tipo de emissão"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pr-lg-5"
          v-if="isElectronic"
        >
          <BaseFormInput
            id-element="numberProcessEditQuotation"
            placeholder="Digite"
            v-model="form.processo.numero_processo"
            required
            validate-on-blur
            v-facade="maskNumberProcess"
            :rules="[requiredInput, numberProcessValid]"
            label-text="Número do Processo"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-lg-5" v-else>
          <BaseFormInput
            id-element="numberProcessEditQuotation"
            placeholder="Digite"
            v-model="form.processo.numero_processo"
            required
            validate-on-blur
            :rules="[requiredInput, maxLengthPhysicalProcess]"
            label-text="Número do Processo"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pr-md-5"
          v-if="hasSelectableCourt"
        >
          <BaseFormSelect
            id-element="justiceRegionEditQuotation"
            placeholder="Seleção"
            v-model="form.processo.tribunal"
            :items="listJusticeRegion"
            item-text="nome"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelCourt"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-md-5" v-else>
          <BaseFormInput
            id-element="justiceRegionEditQuotation"
            placeholder="Digite"
            v-model="form.processo.nome_tribunal"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelCourt"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pl-sm-5 pl-md-0 pr-lg-5"
          v-if="hasSelectableCourt"
        >
          <BaseFormSelect
            id-element="courtJusticeEditQuotation"
            placeholder="Seleção"
            v-model="form.processo.unidade"
            :items="listCourtJustice"
            item-text="nome"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelJusticeRegion"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pl-sm-5 pl-md-0 pr-lg-5"
          v-else
        >
          <BaseFormInput
            id-element="courtJusticeEditQuotation"
            placeholder="Digite"
            v-model="form.processo.nome_unidade"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelJusticeRegion"
          />
        </v-col>
      </fragment>
      <v-col cols="12" sm="6" md="5" lg="4" class="pr-md-5">
        <BaseFormInput
          id-element="numberProposalEditQuotation"
          placeholder="Digite"
          v-model="form.numero_controle_interno"
          label-text="Nº Interno Cliente"
        />
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="officeQuotation"
          placeholder="Seleção"
          v-model="form.escritorio"
          :items="listOfficeQuotation"
          item-text="nome_fantasia"
          item-value="id"
          label-text="Escritório Responsável"
          :return-object="true"
          required
          :rules="[requiredInput]"
          :disabled="disabledOffice"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <div v-if="withRecursal">
      <v-row>
        <v-col cols="12">
          <p class="font-weight-bold primary--text edit-quotation-form__title">
            RECURSOS
          </p>
        </v-col>
      </v-row>
      <div v-for="(element, key) of recursos" :key="key">
        <v-row>
          <v-col cols="10" md="7">
            <BaseFormSelect
              id-element="typeResourceEditQuotation"
              placeholder="Inserir"
              v-model="form.recursos[key].tipo_recurso"
              :items="listResourceType"
              required
              :rules="[requiredInput]"
              label-text="Tipo de Recurso"
              item-text="nome"
              item-value="id"
              :return-object="true"
            />
          </v-col>
          <!-- Adicionar futuramente botão de deletar -->
        </v-row>
        <v-row class="pb-6">
          <v-col cols="12" md="4" class="pr-md-5">
            <BaseMoney
              id-element="valueResourceEditQuotation"
              placeholder="R$ 1.000,00"
              v-model="recursos[key].valor_deposito_recursal"
              required
              :rules="[requiredInput]"
              label-text="Valor de Depósito Recursal"
              text-information="É o valor requerido pela Justiça do Trabalho para admissão de um recurso, sendo uma das condições para garantir futura execução."
              icon-information
            />
          </v-col>
          <v-col cols="12" md="4" class="pr-md-5">
            <BaseFormInput
              id-element="percentResourceEditQuotation"
              placeholder="30%"
              v-model="form.percent"
              disabled
              label-text="Percentual de Agravo*"
            />
          </v-col>
          <v-col cols="12" md="4">
            <label
              for="calculateResourceEditQuotation"
              class="form__label primary--text"
            >
              Importância Segurada
            </label>
            <money
              v-model="calcInsuredAmount"
              v-bind="money"
              disabled
              class="edit-quotation-form__money"
              id="calculateResourceEditQuotation"
            />
          </v-col>
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row class="pb-6" v-else>
      <v-col cols="12">
        <p class="font-weight-bold primary--text edit-quotation-form__title">
          IMPORTÂNCIA SEGURADA
        </p>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseMoney
          id-element="valueResourceEditQuotation"
          placeholder="R$ 1.000,00"
          v-model="form.valor_importancia_segurada"
          required
          :rules="[requiredInput]"
          label-text="Importância Segurada"
        />
      </v-col>
      <v-col cols="12">
        <BaseFormTextArea
          id-element="descriptionResourceQuotation"
          placeholder="Descreva"
          v-model="form.composicao_importancia_segurada"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Composição da Importância Segurada"
          text-information="Aqui você deve descrever o que compõe o valor da importância segurada, exemplo: valor de contrato, agravos previstos em processos, etc..."
          icon-information
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <p class="gray--text font-weight-bold edit-quotation-form__title">
          PRAZOS
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormInput
          id-element="cpfInsuredEditQuotation"
          placeholder="DD/MM/AAAA"
          v-model="inicio"
          required
          :rules="[requiredInput, dateTermValid, isTodayOrGreater]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Início de Vigência"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
        v-if="disabledSliderDeadlineQuotation"
      >
        <BaseFormInput
          id-element="cpfInsuredQuotation"
          placeholder="DD/MM/AAAA"
          v-model="fim_vigencia"
          required
          :rules="[requiredInput, dateTermValid, greaterThanStartDate]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Fim de Vigência"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pb-9" v-else>
        <v-row>
          <v-col cols="12">
            <label for="sliderEditQuotation" class="button gray--text mb-2">
              Prazo (em anos)
            </label>
          </v-col>
          <v-col :cols="sizeSliderCols">
            <v-slider
              id="sliderEditQuotation"
              :tick-labels="labelSlider"
              v-model="form.prazo"
              :min="minRange"
              :max="maxRange"
              track-color="lightGray"
              color="secondary"
              step="1"
              ticks="always"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5 pb-sm-0">
        <div class="edit-quotation-form__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Início de vigência:
          </p>
          <p class="font-weight-bold button primary--text mb-0">
            DE 24HRS DE {{ startTerm }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5 pb-sm-0">
        <div class="edit-quotation-form__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Término de vigência:
          </p>
          <p class="font-weight-bold primary--text mb-0">
            DE 24HRS DE {{ endTerm }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pb-5 pb-sm-0">
        <div class="edit-quotation-form__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Prazo de vigência:
          </p>
          <p class="font-weight-bold primary--text mb-0">
            {{ intervalTerm }} DIAS
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="py-6">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="form__title primary--text">
          ARQUIVOS AUXILIARES
        </p>
        <p class="form__label primary--text mb-2">
          São recomendados anexar os seguintes arquivos:
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pb-5 pb-sm-0 pr-sm-5">
        <div class="edit-quotation-form__type-files pa-4">
          <p
            v-for="(item, key) in form.opcoes.documentos_recomendados"
            :key="key"
            class="primary--text"
          >
            * {{ item }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <DropFile
          @selected-files="addFilesQuotation"
          :multiple="false"
          class="mb-5"
        />
        <DocumentDataTable
          v-if="hasFiles"
          :documents="form.anexos"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFileQuotation"
        />
      </v-col>
    </v-row>
    <slot />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2" class="pb-5 pb-sm-0 pr-sm-5">
          <BaseButton
            v-html="'CANCELAR'"
            color="secondary"
            width="100%"
            outlined
            @click="cancelEdit"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="'SALVAR DADOS'"
            class="white--text secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
const mockEmissionType = [
  {
    title: "PROCESSO FÍSICO",
    id: "fisico"
  },
  {
    title: "PROCESSO ELETRÔNICO",
    id: "eletronico"
  }
];
const mocklistType = [
  {
    id: "pessoa_fisica",
    nome: "PESSOA FÍSICA"
  },
  {
    id: "pessoa_juridica",
    nome: "PESSOA JURÍDICA"
  }
];
const nameRegex = /^([A-zÀ-ÿ'-]+\s*)*[A-zÀ-ÿ']+$/;
import {
  requiredInput,
  isValidCpfOrCnpj,
  dateTermValid,
  numberProcessValid,
  isValidCep,
  maxLengthNumber,
  maxLengthTextArea,
  maxLengthPhysicalProcess,
  documentNumberMatchesType,
  isTodayOrGreater
} from "@/utils/rules.js";
import {
  maskCPFCNPJ,
  maskCEP,
  maskDate,
  maskNumberProcess
} from "@/utils/masks.js";
import { brazilianStates } from "@/utils/utils.js";
import { format, addYears } from "date-fns";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import * as BRUtils from "@brazilian-utils/brazilian-utils";
import _ from "lodash";
import OfficeMixin from "@/mixins/OfficeMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DropFile from "@/components/DropFile.vue";
import DocumentDataTable from "@/components/DocumentDataTable";
import {
  intervalDates,
  parseDateDDMMYYYY,
  convertStringMoneyToNumber
} from "@/utils/formats.js";
import LabelInputMixin from "@/mixins/LabelInputMixin";
export default {
  data: () => ({
    inicio: null,
    formValid: true,
    requiredInput,
    isValidCpfOrCnpj,
    maskCPFCNPJ,
    maskCEP,
    isTodayOrGreater,
    brazilianStates,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    maskDate,
    labelSlider: ["3", "4", "5"],
    minRange: 1,
    maxRange: 10,
    startTerm: "DD/MM/AAAA",
    endTerm: "DD/MM/AAAA",
    dateTermValid,
    listEmissionType: mockEmissionType,
    segmentID: "justica_trabalho",
    typeProcess: {
      title: "Processo Eletrônico",
      id: "eletronico"
    },
    physicalProcess: {
      title: "Processo Físico",
      id: "fisico"
    },
    electronicProcess: {
      title: "Processo Eletrônico",
      id: "eletronico"
    },
    listType: mocklistType,
    numberProcessValid,
    maskNumberProcess,
    formatDateToDDMMYYYY,
    recursos: [],
    isValidCep,
    maxLengthNumber,
    maxLengthPhysicalProcess,
    maxLengthTextArea,
    intervalTerm: null,
    fim_vigencia: null
  }),
  mixins: [
    LoadingRequest,
    CompanyMixin,
    QuotationMixin,
    OfficeMixin,
    DocumentsMixin,
    LabelInputMixin
  ],
  components: {
    DropFile,
    DocumentDataTable
  },
  created() {
    Promise.all([
      this.fetchTaker(),
      this.fetchYears(),
      this.fetchResource(),
      this.isElectronic ? this.fetchNumberProcess() : this.fetchJusticeRegion(),
      this.form.tomador?.grupo?.id && this.fetchOfficeQuotation()
    ]);
    this.formatDateToEdit();
    this.cloneResources();
    this.updateJusticeRegion();
  },
  computed: {
    ...mapState("quotation", [
      "listCourtJustice",
      "listJusticeRegion",
      "eletronicProcessValue",
      "insuredByNameOrCPFCNPJ",
      "listResourceType",
      "listTaker",
      "currentYearsQuotation",
      "listOfficeQuotation"
    ]),
    isElectronic() {
      return this.form.processo?.tipo_processo?.id == "eletronico";
    },
    calcInsuredAmount: {
      get() {
        // por hora esta fazendo apenas para o primeiro
        // pois só tem um, pensar como fazer no futuro
        // quando tiver mais casos
        if (this.recursos[0].valor_deposito_recursal) {
          const convertValue = _.isString(
            this.recursos[0].valor_deposito_recursal
          )
            ? parseFloat(
                this.recursos[0].valor_deposito_recursal.replace(/[\D]+/g, "")
              ) / 100
            : this.recursos[0].valor_deposito_recursal;
          return convertValue + convertValue * 0.3;
        } else {
          return "R$ 0,00";
        }
      },
      set(value) {
        this.form.insuredAmount = value;
      }
    },
    ruleSameType() {
      return documentNumberMatchesType(
        this.form.segurado.tipo_pessoa?.id,
        this.form.segurado.numero_documento
      );
    },
    isValidName() {
      return (
        this.form.segurado.tipo_pessoa?.id == "pessoa_juridica" ||
        (this.form.segurado.tipo_pessoa?.id == "pessoa_fisica" &&
          nameRegex.test(
            this.form.segurado.nome?.nome || this.form.segurado.nome
          )) ||
        "Nome de segurado deve ter nome e sobrenome válidos"
      );
    },
    validTypeDocumentAccordingOptionsQuotation() {
      return this.form.opcoes.segurado[this.form.segurado.tipo_pessoa?.id]
        ?.documento.obrigatorio
        ? [this.requiredInput, this.isValidCpfOrCnpj, this.ruleSameType]
        : [];
    },
    validAddressAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput] : [];
    },
    validCEPAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.isValidCep] : [];
    },
    validNumberAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.maxLengthNumber] : [];
    },
    validAdress() {
      return this.form.opcoes.segurado[this.form.segurado.tipo_pessoa?.id]
        ?.endereco.obrigatorio;
    },
    withRecursal() {
      return this.form.opcoes.recursos.obrigatorio;
    },
    disabledSliderDeadlineQuotation() {
      return this.form.opcoes.fim_vigencia.obrigatorio;
    },
    hasFiles() {
      return this.form.anexos && this.form.anexos.length > 0;
    },
    isAdditionalCoverageRequired() {
      return this.form.opcoes.cobertura_adicional.obrigatorio;
    },
    isContractInfoRequired() {
      return this.form.opcoes.informacoes_contrato.obrigatorio;
    },
    isTypeProcessRequired() {
      return this.form.opcoes.processo_judiciario.tipo_processo.obrigatorio;
    },
    hasSelectableCourt() {
      return !this.form.opcoes.processo_judiciario.tribunal.nome_livre;
    },
    isJudiciaryProcessNumberRequired() {
      return this.form.opcoes.processo_judiciario.numero_processo.obrigatorio;
    },
    isModalityJudicial() {
      return this.form.modalidade.id === "judicial";
    },
    sizeSliderCols() {
      return this.maxRange === this.minRange ? "1" : "12";
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestJusticeRegion",
      "requestNumberProcess",
      "requestCourtJustice",
      "requestInsuredByNameOrCPFCNPJ",
      "requestTaker",
      "requestYearsAccordingEconomicGroup",
      "requestResourceType"
    ]),
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          vm.fetchInsured(value);
          vm.timeout = null;
        }, 500);
    },
    fetchTaker() {
      const payload = {
        grupo_id: this.form.tomador.grupo.id,
        modalidade_id: this.form.modalidade.id,
        submodalidade_id: this.form.submodalidade.id
      };
      this.withLoading(this.requestTaker(payload));
    },
    fetchResource() {
      this.withLoading(this.requestResourceType());
    },
    fetchYears() {
      this.withLoading(
        this.requestYearsAccordingEconomicGroup(this.getPayloadYears())
      );
    },
    getPayloadYears() {
      return {
        grupo: this.form.tomador.grupo.id,
        tomador: this.form.tomador.id,
        modalidade_id: this.form.modalidade.id,
        submodalidade_id: this.form.submodalidade.id
      };
    },
    fetchInsured(value) {
      // se for busca por documento (CPF ou CNPJ),
      // deixar apenas numeros para realizar a busca
      const payload = {
        query:
          value.target.id == "cpfCnpjInsuredEditQuotation"
            ? value.target.value.replace(/[^0-9]/g, "")
            : value.target.value,
        tipoPessoa: this.form.segurado.tipo_pessoa
      };
      // Não sei porque ele perde o valor, então devo guardar ele
      this.form.segurado.numero_documento =
        value.target.id == "cpfCnpjInsuredEditQuotation"
          ? value.target.value
          : this.form.segurado.numero_documento;
      const type =
        value.target.id == "cpfCnpjInsuredEditQuotation"
          ? "numero_documento"
          : "nome";
      this.withLoading(this.requestInsuredByNameOrCPFCNPJ(payload));
      this.autocompleteFormAccordingInput(payload.query, type);
    },
    autocompleteFormAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      const newValue =
        input == "numero_documento" ? value.replace(/[^0-9]/g, "") : value;
      const item = this.insuredByNameOrCPFCNPJ.find(x => x[input] == newValue);
      if (item) {
        const newForm = _.pick(item, ["tipo_pessoa", "endereco", "nome", "id"]);
        this.form.segurado.numero_documento = !BRUtils.isValidCNPJ(
          item.numero_documento
        )
          ? BRUtils.formatCPF(item.numero_documento)
          : BRUtils.formatCNPJ(item.numero_documento);
        this.form.segurado = this.mergeProperties(newForm, this.form.segurado);
      }
    },
    autocompleteTakerAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      if (this.listTaker.length >= 1) {
        const newTaker = _.pick(
          this.listTaker.find(x => x[input] == value),
          ["ativo", "cnpj", "id", "nome_fantasia", "razao_social", "status"]
        );
        this.form.tomador = this.mergeProperties(newTaker, this.form.tomador);
        this.fetchYears();
      }
    },
    selectedItem(item) {
      this.form.processo.tipo_processo = item;
    },
    fetchJusticeRegion() {
      if (this.isJudiciaryProcessNumberRequired && this.hasSelectableCourt)
        this.withLoading(
          this.requestJusticeRegion(
            this.form.processo.segmento?.id ||
              this.form.processo.tribunal?.segmento?.id
          )
        );
    },
    fetchNumberProcess() {
      this.withLoading(
        this.requestNumberProcess(this.getPayloadNumberProcess())
      );
    },
    fetchCourtJustice() {
      this.withLoading(this.requestCourtJustice(this.getPayloadCourtJustice()));
    },
    getPayloadNumberProcess() {
      return {
        id:
          this.form.processo.segmento?.id ||
          this.form.processo.tribunal?.segmento?.id,
        number: this.form.processo.numero_processo
      };
    },
    getPayloadCourtJustice() {
      return {
        segmentID:
          this.form.processo.segmento?.id ||
          this.form.processo.tribunal?.segmento?.id,
        justiceID: this.form.processo.tribunal?.id
      };
    },
    cancelEdit() {
      this.$emit("return");
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.withRecursal) {
          this.form.recursos.forEach((item, index) => {
            item.valor_deposito_recursal = this.recursos[
              index
            ].valor_deposito_recursal;
          });
        }
        this.form.inicio_vigencia = this.dateISO(this.inicio);
        if (this.fim_vigencia)
          this.form.fim_vigencia = this.dateISO(this.fim_vigencia);
        // Verificar se o elemento escolhido tem os mesmos valores da tabela conforme
        // o id, se não tiver, devo deixar null o id
        const item = this.insuredByNameOrCPFCNPJ.find(
          x => x.id == this.form.segurado.id
        );
        this.form.segurado.id =
          item?.nome == this.form.segurado.nome ? this.form.segurado.id : null;
        this.form.valor_importancia_segurada = convertStringMoneyToNumber(
          this.form.valor_importancia_segurada
        );
        // Sem fazer a cópia, o valor da importância segurada
        // continua como string
        const payload = _.cloneDeep(this.form);
        this.$emit("submit", payload);
      }
    },
    updateIntervalDate() {
      // Trocar valores apenas quando a data
      // estiver no formato correto
      if (this.form.prazo && !this.disabledSliderDeadlineQuotation) {
        const date_start = parseDateDDMMYYYY(this.inicio);
        this.startTerm = this.inicio;
        let endDate = addYears(date_start, this.form.prazo);
        this.endTerm = format(endDate, "dd/MM/yyyy");
        this.intervalTerm = intervalDates(this.inicio, this.endTerm);
      } else if (this.fim_vigencia && this.disabledSliderDeadlineQuotation) {
        this.startTerm = this.inicio;
        this.endTerm = this.fim_vigencia;
        this.intervalTerm = intervalDates(this.inicio, this.fim_vigencia);
      }
    },
    formatDateToEdit() {
      this.inicio = this.formatDateToDDMMYYYY(this.form.inicio_vigencia);
      this.fim_vigencia = this.formatDateToDDMMYYYY(this.form.fim_vigencia);
    },
    cloneResources() {
      this.recursos = _.cloneDeep(this.form.recursos);
    },
    greaterThanStartDate(value) {
      if (!value) return true;
      const endDate = parseDateDDMMYYYY(this.fim_vigencia);
      const startDate = parseDateDDMMYYYY(this.inicio);
      return (
        endDate > startDate ||
        "Término da vigência deve ser posterior ao início"
      );
    },
    addFilesQuotation(files) {
      this.form.anexos = this.addFiles(this.form.anexos, files);
    },
    onRemoveFileQuotation(file) {
      this.form.anexos = this.onRemoveFile(this.form.anexos, file);
    },
    fetchProcessItems() {
      if (!this.isJudiciaryProcessNumberRequired) return;
      this.isElectronic ? this.fetchNumberProcess() : this.fetchJusticeRegion();
    },
    updateJusticeRegion() {
      // Caso não venha valor, devo adotar como primeiro item da lista
      // que será o 'NÃO SE APLICA', pois enviando este valor para
      // o back, continua salvo null para este elemento
      this.form.processo.unidade = !this.form.processo.unidade
        ? this.listCourtJustice[0]
        : this.form.processo.unidade;
    }
  },
  props: {
    form: {
      type: Object
    }
  },
  watch: {
    "form.segurado.numero_documento"(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.numero_documento == oldValue?.numero_documento
      )
        return;
      const item = newValue?.id || newValue.replace(/[^0-9]/g, "");
      const type = newValue?.id ? "id" : "numero_documento";
      this.autocompleteFormAccordingInput(item, type);
    },
    "form.segurado.nome"(newValue, oldValue) {
      if (!newValue || newValue == oldValue || newValue == oldValue?.nome)
        return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "nome";
      this.autocompleteFormAccordingInput(item, type);
    },
    "form.tomador.nome_fantasia"(value) {
      this.autocompleteTakerAccordingInput(value, "nome_fantasia");
    },
    "form.tomador.cnpj"(value) {
      this.autocompleteTakerAccordingInput(value, "cnpj");
    },
    inicio(value) {
      this.dateTermValid(value) != "Data inválida" && this.updateIntervalDate();
    },
    "form.prazo"() {
      this.updateIntervalDate();
    },
    fim_vigencia(value) {
      this.dateTermValid(value) != "Data inválida" && this.updateIntervalDate();
    },
    "form.processo.tipo_processo"(value) {
      if (value.id == this.physicalProcess.id) this.fetchJusticeRegion();
    },
    "form.processo.numero_processo"(value) {
      value &&
        value.length == 25 &&
        this.form.processo.tipo_processo.id == this.electronicProcess.id &&
        this.fetchNumberProcess();
    },
    "form.processo.tribunal"(value) {
      if (value && this.hasSelectableCourt) this.fetchCourtJustice();
    },
    eletronicProcessValue(value) {
      if (this.form.processo.tipo_processo.id == this.electronicProcess.id) {
        this.form.unidade = value.unidade;
        this.form.tribunal = value.tribunal;
      }
    },
    currentYearsQuotation(value) {
      if (value.length == 0) return;
      const label = value.map(item => item.anos);
      this.labelSlider = [...label];
      this.minRange = _.head(value).anos;
      // https://stackoverflow.com/questions/3216013/get-the-last-item-in-an-array
      // No link acima, tem um teste de performance
      // mostrando o método mais rápido
      this.maxRange = _.last(value).anos;
    },
    "form.tomador.grupo.id"(value) {
      if (value) this.fetchOfficeQuotation();
    }
  }
};
</script>
<style lang="sass">
.edit-quotation-form__
  &title
    font-size: 18px
  &footer
    border-top: 1px solid #D5D5E0 !important
    background: white !important
  &validity-col
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #F0F0F7
  &money
    height: 40px
    padding: 0 12px
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    width: 100%
    margin-top: 8px
    background-color: #F0F0F7
    color: #676778
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
</style>
